import { vuexHandbook } from '@/store/composition/handbook'
import { ChamferApi } from '@/api/handbook/position/Chamfer/ChamferApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: ChamferApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
